import { EmailEntityId } from "@sp-crm/core";
import React from "react";
import {
    AdvancedSearchEntityType,
    useGetConversationFeedForEntityQuery,
} from "../../generated/graphql";
import { ErrorMessage } from "../ui/error-message";
import { Spinner } from "../ui/spinner";
import { ConversationFeed } from "./conversation-feed";

interface EntityConversationFeedProps {
    entityId: EmailEntityId;
    initialThreadId?: string;
    entityType?: AdvancedSearchEntityType;
}

export const EntityConversationFeed: React.FC<EntityConversationFeedProps> = props => {
    const { entityId, initialThreadId, entityType } = props;

    const conversationQuery = useGetConversationFeedForEntityQuery({ entityId });

    if (conversationQuery.isLoading) {
        return <Spinner />;
    }

    if (conversationQuery.isError) {
        return (
            <ErrorMessage component="EntityConversationFeed">
                <pre>{JSON.stringify(conversationQuery.error, null, 2)}</pre>
            </ErrorMessage>
        );
    }

    if (!conversationQuery.data?.getConversationFeedForEntity) {
        return <Spinner />;
    }

    return (
        <ConversationFeed
            feed={conversationQuery.data.getConversationFeedForEntity}
            initialThreadId={initialThreadId}
            entityType={entityType}
        />
    );
};
